import { Autocomplete, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getRopa, postEvento } from '../../../services/apis';
import { AlertError, AlertSuccess } from '../../../utils/componentes-utiles/AlertError';

export const FormCamisetas = ({ tEventoSelec, fecha, cargarEventos, cerrarFormulario }) => {

    const [ropa, setRopa] = useState([]);
    const [ropaSelect, setRopaSelect] = useState(null)
    const [horaInicio, setHoraInicio] = useState();
    const [errorAlert, setErrorAlert] = useState(false);
    const [successAlert, setSuccessAlert] = useState(false);

    const isNullInObject = (obj) => {
        // Camps que s'ometen en la validació
        const camposExcepcion = ['usuarioEncargado'];

        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const handleSubmit = () => {
        let fechaFomat = "";
        const [dia, mes, anio] = fecha.split('-');
        fechaFomat = `${anio}-${mes}-${dia}`;
        console.log(fechaFomat);

        const data = {
            asunto: ropaSelect.label,
            descripcion: ropaSelect.label,
            horaInicio: horaInicio,
            fecha: fechaFomat,
            gastaTicket: false,
            usuarioEncargado: null,
            id_tipoEvento: 4,
        };


        // const tareaComprobada = isNullInObject(data);

        // if (!tareaComprobada) {
        //     console.error("Hi ha camps buits o no vàlids en l'esdeveniment");
        //     setErrorAlert(true);
        //     return; // Detener la ejecución si hay campos no válidos
        // }
        // console.log(data);

        crearEvento(data);
        console.log("Dades de la roba:", data);

    };

    const crearEvento = async (data) => {

        try {
            const resposne = await postEvento(data);
            console.log("Esdeveniment creat:", resposne);
            if (resposne.success) {
                setSuccessAlert(true);
                cargarEventos();
                cerrarFormulario();
            }


        }
        catch (error) {
            console.error("Error en crear l'esdeveniment:", error);
        }
    };


    const cargarRopa = async () => {
        try {
            const response = await getRopa();
            console.log(response);

            if (response.success) {
                iterarRopa(response.data)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const iterarRopa = (data) => {
        try {
            const tmp = [...data];
            const newTmp = tmp.map((item) => ({
                label: item.nombre,
                value: item.id,
            }));
            setRopa(newTmp);
            setRopaSelect(newTmp[0] || null);
        } catch (error) {
            console.error("Error en carregar roba", error);
        }
    };

    useEffect(() => {
        cargarRopa();
    }, [])



    return (
        <Grid
            container
            direction="row"
            className="ki-section-row-center events-create-section events-type-clothes"
            size={{ xs: 12 }}
            spacing={2}
            sx={{ display: tEventoSelec == 4 ? 'flex' : 'none' }}>
            <Grid size={{ xs: 11 }}>
                <Typography className="events-create-section-title">Roba</Typography>
            </Grid>
            <Grid
                container
                direction="row"
                gap={2}
                size={{ xs: 11 }}
                sx={{ justifyContent: "start", alignItems: "start" }}>
                <Grid
                    size={{ xs: 12 }}>
                    <Autocomplete
                        fullWidth
                        className={ropa ? "inputDateInput" : 'inputDateInput-empty'}
                        disablePortal
                        id="combo-box-demo"
                        options={ropa}
                        value={ropaSelect}
                        onChange={(event, newValue) => setRopaSelect(newValue)}
                        renderInput={(params) => <TextField {...params} label="Seleccionar roba*" />}
                    />
                </Grid>


                <Grid
                    size={{ xs: 12 }}>
                    <TextField
                        fullWidth
                        label="Hora d'inici"
                        type="time"
                        value={horaInicio || ""}
                        onChange={(e) => setHoraInicio(e.target.value)}
                        InputLabelProps={{
                            shrink: true, // perquè l'etiqueta no se solape
                        }}
                    />
                </Grid>

                <Grid
                    size={{ xs: 12 }}>
                    <Button variant="contained" color="primary" fullWidth
                        onClick={handleSubmit}
                    >
                        Guardar roba
                    </Button>
                </Grid>

            </Grid>
            {errorAlert && (
                <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta omplir algun camp obligatori"} />
            )}
            {successAlert && (
                <AlertSuccess open={successAlert} setOpen={setSuccessAlert} titulo={"Èxit"} mensaje={"Roba creada correctament"} tipo={"success"} />
            )}
        </Grid>
    )
}
